/* Progressive enhancement of the theme's shared navigation and mega-menu output. */
(() => {
  if (window.acustomMobileMenu || !window.HTMLDialogElement || typeof HTMLDialogElement.prototype.showModal !== 'function') return;
  window.acustomMobileMenu = true;
  let dialog;
  let opener;
  let stack = [];
  let oldOverflow;
  let pageY;
  let oldBodyStyle;
  const text = (el) => el?.textContent.trim() || '';
  const destination = (href) => href && !['#', '/', 'http://', 'https://'].includes(href);

  // Use the same configured categories, capsule and calls to action as desktop.
  function readShop() {
    const source = document.querySelector('.acustom-shop-mega__inner');
    if (!source) return null;
    const groups = Array.from(source.querySelectorAll('.acustom-shop-mega__group')).map(group => {
      const heading = group.querySelector('h2');
      return { title: text(heading), href: heading.querySelector('a')?.getAttribute('href'),
        children: Array.from(group.querySelectorAll('ul a')).map(a => ({ title: text(a), href: a.getAttribute('href'), children: [] })) };
    });
    if (!groups.length) return null;
    const feature = source.querySelector('.acustom-shop-mega__feature');
    if (feature) groups.push({ feature });
    const actions = source.querySelector('.acustom-shop-mega__bottom');
    if (actions) groups.push({ actions });
    return groups;
  }

  function readItems(container) {
    return Array.from(container.children).flatMap((item) => {
      if (item.tagName === 'TEMPLATE') return [];
      if (!text(item) && !item.querySelector('img, input, select, button, form') && item.tagName !== 'HR') return [];
      // Turbo wraps injected mega menus in an extra div.
      if (item.matches('[data-meganav-mobile]')) return readItems(item);
      const anchor = item.querySelector(':scope > a');
      const nested = item.querySelector(':scope > ul');
      if (anchor && !anchor.querySelector('img')) {
        return [{ title: ({ SHOP: 'Shop', APPOINTMENTS: 'Appointments', 'LEARN MORE': 'Learn more' }[text(anchor)] || text(anchor)), href: anchor.getAttribute('href'), current: anchor.getAttribute('aria-current'),
          children: text(anchor).toLowerCase() === 'shop' ? (readShop() || (nested ? readItems(nested) : [])) : (nested ? readItems(nested) : []) }];
      }
      // Keep localization forms, account headings, imagery, and editorial content.
      const content = item.cloneNode(true);
      content.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      content.removeAttribute('id');
      return [{ content, original: item }];
    });
  }

  function element(tag, className, label) {
    const el = document.createElement(tag);
    el.className = className;
    if (label) el.textContent = label;
    return el;
  }

  function render(focusIndex) {
    const current = stack[stack.length - 1];
    dialog.replaceChildren();
    const header = element('div', 'acustom-menu__header');
    const back = element('button', 'acustom-menu__back', '‹');
    back.type = 'button';
    back.setAttribute('aria-label', stack.length > 1 ? `Back to ${stack[stack.length - 2].title}` : 'Back');
    back.hidden = stack.length === 1;
    back.addEventListener('click', () => {
      const previous = stack.pop();
      render(previous.index);
    });
    const title = element('h2', 'acustom-menu__title', current.title);
    title.id = 'acustom-menu-title';
    title.tabIndex = -1;
    if (stack.length === 1) {
      header.classList.add('acustom-menu__header--root');
      const brand = document.querySelector('.header__logo .primary_logo');
      if (brand) {
        const logo = document.createElement('img');
        logo.src = brand.currentSrc || brand.getAttribute('src');
        logo.alt = brand.alt || 'Acustom Apparel';
        logo.className = 'acustom-menu__logo';
        title.replaceChildren(logo);
      } else title.textContent = 'Acustom Apparel';
    }
    const close = element('button', 'acustom-menu__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close menu');
    close.addEventListener('click', () => dialog.close());
    header.append(back, title, close);
    const nav = element('nav', 'acustom-menu__body');
    nav.setAttribute('aria-label', current.title);
    const list = element('ul', 'acustom-menu__list');
    if (destination(current.href) && !current.items.some(item => item.href === current.href)) {
      const li = document.createElement('li');
      const all = element('a', 'acustom-menu__all', current.title.toLowerCase() === 'shop' ? 'Shop all' : `Shop all ${current.title.toLowerCase()}`);
      all.href = current.href;
      all.setAttribute('data-no-instant', '');
      li.append(all);
      list.append(li);
    }
    current.items.forEach((item, index) => {
      const li = document.createElement('li');
      if (item.feature) {
        li.className = 'acustom-menu__feature';
        const link = element('a', 'acustom-menu__capsule');
        link.href = item.feature.getAttribute('href');
        const image = item.feature.querySelector('img')?.cloneNode(true);
        if (image) { image.removeAttribute('id'); image.sizes = '112px'; link.append(image); }
        const caption = element('span', 'acustom-menu__capsule-copy');
        caption.append(element('span', 'acustom-menu__eyebrow', 'Seasonal capsule'));
        caption.append(element('strong', '', text(item.feature.querySelector('strong'))));
        link.append(caption);
        li.append(link);
      } else if (item.actions) {
        li.className = 'acustom-menu__actions';
        Array.from(item.actions.querySelectorAll('a')).forEach(original => {
          const gift = original.classList.contains('acustom-shop-mega__gifting');
          const link = element('a', gift ? 'acustom-menu__gift' : 'acustom-menu__appointment');
          link.href = original.getAttribute('href');
          if (gift) {
            const icon = original.querySelector('svg');
            if (icon) link.append(icon.cloneNode(true));
            link.append(document.createTextNode('Gifting'));
          } else {
            link.append(element('span', 'acustom-menu__appointment-title', 'Book an appointment'));
            link.append(element('span', 'acustom-menu__appointment-note', 'Visit us in Soho or meet by video'));
          }
          li.append(link);
        });
      } else if (item.content) {
        li.className = 'acustom-menu__content';
        const content = item.content.cloneNode(true);
        // The legacy currency converter binds directly to its original buttons.
        if (item.original.closest('[data-currency-converter]')) {
          content.querySelectorAll('button').forEach((button, index) => {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              item.original.querySelectorAll('button')[index]?.click();
              dialog.close();
            });
          });
        }
        if (content.tagName === 'LI') li.append(...content.childNodes);
        else li.append(content);
      } else {
        const hasChildren = item.children.length > 0;
        const row = element(hasChildren ? 'button' : 'a', 'acustom-menu__row', item.title);
        row.dataset.row = index;
        if (hasChildren) {
          row.type = 'button';
          row.setAttribute('aria-label', `${item.title}, open submenu`);
          row.append(element('span', 'acustom-menu__chevron', '›'));
          row.lastChild.setAttribute('aria-hidden', 'true');
          row.addEventListener('click', () => {
            stack.push({ title: item.title, href: item.href, items: item.children, index });
            render();
          });
        } else {
          row.href = item.href || '#';
          row.setAttribute('data-no-instant', '');
          if (item.current) row.setAttribute('aria-current', item.current);
        }
        li.append(row);
      }
      list.append(li);
    });
    nav.append(list);
    dialog.append(header, nav);
    (focusIndex !== undefined ? dialog.querySelector(`[data-row="${focusIndex}"]`) : title)?.focus();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mobile-menu-trigger]');
    if (!trigger) return;
    const source = document.getElementById('mobile_menu');
    if (!source) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (dialog?.isConnected) return;
    opener = trigger;
    dialog = element('dialog', 'acustom-menu');
    dialog.setAttribute('aria-labelledby', 'acustom-menu-title');
    document.body.append(dialog);
    stack = [{ title: 'Menu', items: readItems(source) }];
    render();
    oldOverflow = document.documentElement.style.overflow;
    oldBodyStyle = { position: document.body.style.position, top: document.body.style.top, width: document.body.style.width };
    pageY = window.scrollY;
    document.documentElement.style.overflow = 'hidden';
    Object.assign(document.body.style, { position: 'fixed', top: `-${pageY}px`, width: '100%' });
    opener.setAttribute('aria-expanded', 'true');
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = oldOverflow;
      Object.assign(document.body.style, oldBodyStyle);
      window.scrollTo(0, pageY);
      opener.setAttribute('aria-expanded', 'false');
      opener.focus({ preventScroll: true });
      dialog.remove();
    }, { once: true });
    dialog.showModal();
    dialog.querySelector('h2').focus();
  }, true);

  // Return to the page if the viewport changes to the desktop header.
  window.addEventListener('resize', () => {
    if (dialog?.open && opener.getClientRects().length === 0) dialog.close();
  });
  document.addEventListener('shopify:section:unload', () => {
    if (dialog?.open) dialog.close();
  });
})();
